import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-mockup',
  templateUrl: './product-mockup.component.html',
  styleUrls: ['./product-mockup.component.css']
})
export class ProductMockupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


  FFS_Mob(){
    window.open('/assets/Mockup/FFS_Mob.pdf', '_blank');
}

FFS_Web(){
  window.open('/assets/Mockup/FFS_Web.pdf', '_blank');
}

Fruit_Inventory_Mockup(){
    window.open('/assets/Mockup/Fruit_Inventory_Mockup.pdf', '_blank');
}


shopAct(){
  window.open('/assets/Mockup/shopAct.pdf', '_blank');
}




}
